import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Download from '~/components/Download';
import downloadFile from '~/utils/downloadFile';
import { useSelector } from 'react-redux';
import MatchTeam from '../components/MatchTeam';
import * as S from '../styles';
import { propTypes, defaultProps } from './propsValidation';

export default function MatchSheetDesktop({
  selectedMatch,
  lineUp,
  publicFiles,
}) {
  const { t } = useTranslation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const [pdfLoading, setPdfLoading] = useState(false);

  return (
    <S.MatchSheetContainer>
      {selectedMatch && (
        <MatchTeam
          team={selectedMatch.homeTeam}
          squad={
            lineUp.homeTeamLineUp ? lineUp.homeTeamLineUp.startPlayers : []
          }
          trainer={lineUp.homeTeamLineUp ? lineUp.homeTeamLineUp.trainer : {}}
          formation={
            lineUp.homeTeamLineUp ? lineUp.homeTeamLineUp.playersFormation : []
          }
          isLocal
        />
      )}
      {selectedMatch && (
        <MatchTeam
          team={selectedMatch.awayTeam}
          squad={
            lineUp.awayTeamLineUp ? lineUp.awayTeamLineUp.startPlayers : []
          }
          trainer={lineUp.awayTeamLineUp ? lineUp.awayTeamLineUp.trainer : {}}
          formation={
            lineUp.awayTeamLineUp ? lineUp.awayTeamLineUp.playersFormation : []
          }
        />
      )}
      <Download
        onClick={() => {
          if (publicFiles.data.hojaPartido)
            downloadFile(publicFiles.data.hojaPartido.id, setPdfLoading);
        }}
        disabled={
          Object.keys(publicFiles.data).length === 0 ||
          !publicFiles.data.hojaPartido
        }
        text={t('downloadSheetDesignation')}
        loading={pdfLoading}
        competition={match?.competitionId}
      />
    </S.MatchSheetContainer>
  );
}

MatchSheetDesktop.propTypes = propTypes;

MatchSheetDesktop.defaultProps = defaultProps;
